var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bls-code-container"
  }, [_vm._l(['Bodypart', 'Event', 'Nature', 'Source'], function (code_type) {
    return [_vm._l(_vm.availableLevels[code_type], function (level) {
      return [_vm._v("\n      BLS " + _vm._s(code_type) + " " + _vm._s(_vm.labelForLevel(level)) + " Category:\n      "), _c('ChildSelect', {
        key: `${code_type} - ${level}`,
        staticClass: "child-select",
        attrs: {
          "id": `${code_type}-${level}-raft-select`,
          "disabled": _vm.disabledFor({
            level,
            code_type
          }) || _vm.disabled,
          "options": _vm.formattedOptions({
            level: level,
            code_type: code_type,
            parentId: _vm.valueFor({
              level: level - 1,
              code_type
            })
          }),
          "selected-value": _vm.getSelectedValue(code_type, level)
        },
        on: {
          "select": _vm.childSelect
        }
      })];
    })];
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }